import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { EstadoSolicitudExtranjero, TABLE_CONSTANTS } from "@/shared";
import { Edit } from "@mui/icons-material";
import { useUiStore } from "@/store/ui";
import { useFetchSolicitudExtranjero, usePutSolicitudExtranjero } from "@/shared/actions/erp/solicitud_extranjero/solicitud_extranjero.actions";
import { SolicitudExtranjero } from "@/shared/interfaces/erp/solicitud_extranjero/solicitud_extranjero.interface";
import { useTableColumnsSolicitudExtranjeros } from "../hooks/useTableColumnsSolicitudExtranjeros";
import { useAuthStore } from "@/store/auth";

interface TableSolicitudExtranjeroProps {
  estado_solicitud?: EstadoSolicitudExtranjero
  enableActions?: boolean
}
export default function TableSolicitudExtranjero({
  estado_solicitud = EstadoSolicitudExtranjero.EN_ESPERA,
  enableActions = true
}: TableSolicitudExtranjeroProps) {

  ///* Hooks
  const {
    columnsBase
  } = useTableColumnsSolicitudExtranjeros({
    estado_solicitud
  });

  const {
    pagination,
    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } =
    useTableServerSideFiltering();

  const { isLoading, data: prospectoRes, isRefetching } =
    useFetchSolicitudExtranjero({
      page: pageIndex + 1,
      estado_solicitud: estado_solicitud,
      page_size: pageSize,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });

  const {
    mutateAsync: mutateAsyncPut
  } = usePutSolicitudExtranjero({})

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const username = useAuthStore(s => s.user)?.username

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<SolicitudExtranjero>
            columns={columnsBase}
            data={prospectoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}

            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={prospectoRes?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableActions}
            showCustomActionBtnSpace={enableActions}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    <Tooltip title={'Editar'} placement="top">
                      <IconButton
                        onClick={() => {
                          setConfirmDialogIsOpen(true);

                          setConfirmDialog({
                            isOpen: true,
                            title: '¡Liberar extranjero TEMPORAL!',
                            subtitle: `Estás a punto de liberar a un cliente con residencia temporal. Este cambio no se puede deshacer. ¿Estás seguro de continuar?`,
                            confirmTextBtn: 'Confirmar',
                            onClose() {
                              setConfirmDialogIsOpen(false);
                            },

                            async onReject() {

                              await mutateAsyncPut({
                                id: value.id_solicitud_extrangero_prospecto,
                                data: {
                                  estado_solicitud: EstadoSolicitudExtranjero.RECHAZADO,
                                  user_aprueba: username
                                }
                              })

                              setConfirmDialogIsOpen(false);
                            },
                            async onConfirm() {
                              await mutateAsyncPut({
                                id: value.id_solicitud_extrangero_prospecto,
                                data: {
                                  estado_solicitud: EstadoSolicitudExtranjero.APROBADO,
                                  user_aprueba: username
                                }
                              })
                              setConfirmDialogIsOpen(false);
                            },
                            cancelTextBtn: 'Cerrar',
                          });
                        }
                        }
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }}

          />
        </Grid>
      </Grid>



    </>
  );
}